module.exports = __webpack_public_path__ + "img/conference.50bb60cc.png";